import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Button from "../../shared/Button"
import { BarChart, PieChart } from "@mui/x-charts"
import { getArchivedLoadRecordsAndReasonReport, getAverageVehicleSupplyTimeReport } from "../../../features/reports/reportSlice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1500px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .content{
            margin-block: 20px;
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            .title-list{
                display:grid;
                grid-template-columns: repeat(8, 1fr);
                width: 100%;
                gap: 20px;
                text-align: center;
                align-items: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                margin-bottom: 20px;
                padding-bottom: 10px;
                border-bottom: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                
            }
            .main-side{
                text-align: center;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .info{
                    display:grid;
                    grid-template-columns: repeat(8, 1fr);
                    gap: 20px;
                    .text{
                        text-align: center;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                }
            }
            .total-container{
                display:grid;
                grid-template-columns: repeat(8, 1fr);
                text-align: center;
                gap: 20px;
                width: 100%;
                margin-top: 20px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                border-top: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                padding-top: 10px;
                .total{
                    font-weight: var(--font-weight-lg);
                    font-size: var(--font-size-md);
                }
            }
            .charts{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                margin-top: 30px;
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 20px;
        }
    }
`

const titles = ["Ay", "Girilen Yük Kaydı Sayısı", "Arşive Alınan Yük Kaydı Sayısı", "Arşive Alınma Oranı", "Nakliyeden Vazgeçildi"," Yük Verildi", "Teklif Gelmedi", "Uygun Teklif Gelmedi"]


const ArsivYukveGerekceModal = () => {

    const dispatch = useDispatch()

    const location = useLocation()
    const {arsivYukGerekceRaporList } = useSelector(state => state.report)
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const companyId = JSON.parse(storage.getItem("companyId"))    

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(() => {
        dispatch(getArchivedLoadRecordsAndReasonReport(companyId))
    }, [companyId])

    const seriesData = [
        {
            data:  [
                { id: 1, value: arsivYukGerekceRaporList?.yearlyTransportCanceled?.count, label: 'Nakliyeden Vazgeçildi', color:"#E85446" },
                { id: 2, value: arsivYukGerekceRaporList?.yearlyLoadGiven?.count, label: 'Yük Verildi', color:"#3498DB" },
                { id: 3, value: arsivYukGerekceRaporList?.yearlyNoOfferReceived?.count, label: 'Teklif Gelmedi', color:"#F1C40F" },
                { id: 4, value: arsivYukGerekceRaporList?.yearlyNoSuitableOfferReceived?.count, label: 'Uygun Teklif Gelmedi', color:"#8E44AD" },
            ]
        },
    ]


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
            <PageTopTitle title={"Arşive Alınan Yük Kayıtları ve Gerekçeleri Raporu"}/>
            <div className="content">
                
                <div className="title-list">
                    {titles.map((item) => (
                        <div className="title">{item}</div>
                    ))}
                </div>
                <div className="main-side">
                    {arsivYukGerekceRaporList?.monthlyReports?.$values?.map((item) => {
                        return (
                            <div className="info">
                                <div className="text">{item?.month}</div>
                                <div className="text">{item?.archivedLoadRecordCount}</div>
                                <div className="text">{item?.enteredLoadRecordCount}</div>
                                <div className="text">{parseInt(item?.archiveRate)}%</div>
                                <div className="text">{item?.transportCanceled?.count} ({parseInt(item?.transportCanceled?.rate)}%)</div>
                                <div className="text">{item?.loadGiven?.count} ({parseInt(item?.loadGiven?.rate)}%)</div>
                                <div className="text">{item?.noOfferReceived?.count} ({parseInt(item?.noOfferReceived?.rate)}%)</div>
                                <div className="text">{item?.noSuitableOfferReceived?.count} ({parseInt(item?.noSuitableOfferReceived?.rate)}%)</div>
                            </div>
                        )
                    })}
                    
                </div>
                <div className="total-container">
                    <div className="total">Toplam</div>
                    <div className="calc">{arsivYukGerekceRaporList?.yearlyEnteredLoadRecordCount}</div>
                    <div className="calc">{arsivYukGerekceRaporList?.yearlyArchivedLoadRecordCount}</div>
                    <div className="calc">{parseInt(arsivYukGerekceRaporList?.yearlyArchiveRate)}%</div>
                    <div className="calc">{arsivYukGerekceRaporList?.yearlyTransportCanceled?.count} ({parseInt(arsivYukGerekceRaporList?.yearlyTransportCanceled?.rate)}%)</div>
                    <div className="calc">{arsivYukGerekceRaporList?.yearlyLoadGiven?.count} ({parseInt(arsivYukGerekceRaporList?.yearlyLoadGiven?.rate)}%)</div>
                    <div className="calc">{arsivYukGerekceRaporList?.yearlyNoOfferReceived?.count} ({parseInt(arsivYukGerekceRaporList?.yearlyNoOfferReceived?.rate)}%)</div>
                    <div className="calc">{arsivYukGerekceRaporList?.yearlyNoSuitableOfferReceived?.count} ({parseInt(arsivYukGerekceRaporList?.yearlyNoSuitableOfferReceived?.rate)}%)</div>
                </div>
                <div className="charts">
                    <PieChart
                        series={seriesData}
                        width={600}
                        height={200}
                    />
                </div>
            </div>
            <div className='button-grp'>
                <Button color={"#F4F4F4"} background={"#E85446"} width="310px" radius={"10px"} text={"Geri Dön"} handleClick={()=> dispatch(showModal(null))}/>
            </div>
        </div>
    </ModalContainer>
  )
}

export default ArsivYukveGerekceModal